export enum TinKind {
    NIP = 'NIP',
    VATIN = 'VATIN',
    PESEL = 'PESEL',
    OtherID = 'OtherID'
}
